import { getFontSize } from '../../../utilities/getFontSize.js';
import styles from './GroupLabel.scss.js';
import { jsx } from 'react/jsx-runtime';
import { estimateStringWidthWithOffset } from '../../../utilities/estimateStringWidthWithOffset.js';
import { useTheme, HORIZONTAL_GROUP_LABEL_HEIGHT } from '@shopify/polaris-viz-core';

const LABEL_RIGHT_PADDING = 15;
function GroupLabel({
  areAllNegative,
  containerWidth,
  label,
  zeroPosition
}) {
  const fontSize = getFontSize();
  const labelWidth = estimateStringWidthWithOffset(label, fontSize);
  const selectedTheme = useTheme();
  const maxWidth = areAllNegative ? labelWidth + LABEL_RIGHT_PADDING : containerWidth - zeroPosition;
  return /*#__PURE__*/jsx("foreignObject", {
    height: HORIZONTAL_GROUP_LABEL_HEIGHT,
    width: "100%",
    x: zeroPosition + (areAllNegative ? labelWidth * -1 : 0),
    "aria-hidden": "true",
    children: /*#__PURE__*/jsx("div", {
      className: styles.Label,
      style: {
        background: selectedTheme.chartContainer.backgroundColor,
        fontSize: `${fontSize}px`,
        color: selectedTheme.yAxis.labelColor,
        maxWidth,
        height: HORIZONTAL_GROUP_LABEL_HEIGHT,
        width: labelWidth + LABEL_RIGHT_PADDING
      },
      children: label
    })
  });
}

export { GroupLabel };
